import * as React from "react";

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 12h-2.625a.376.376 0 01-.375-.375v-.75c0-.206.169-.375.375-.375H13A1.5 1.5 0 0014.5 9V3A1.5 1.5 0 0013 1.5h-2.625A.376.376 0 0110 1.125v-.75c0-.206.169-.375.375-.375H13a3 3 0 013 3v6a3 3 0 01-3 3zM5.222.61l-.613.612a.37.37 0 00.007.534L8.15 5.187H.375A.376.376 0 000 5.563v.875c0 .207.169.375.375.375H8.15l-3.534 3.429a.376.376 0 00-.007.534l.613.612a.375.375 0 00.531 0l5.138-5.125a.375.375 0 000-.53L5.753.605a.378.378 0 00-.531.003z",
    fill: "currentColor"
  }));
};

export default SvgComponent;